import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import CustomPanelTab from "../../common/CustomPanelTab";

import User from "../User";
import SuperUser from "../SuperUser";
import Ambassador from "../Ambassador";
import RegisteredOrganization from "../RegisteredOrganization";
import Therapist from "../Therapist";

function PanelUser(props) {
    const { role } = JSON.parse(localStorage.getItem("admin-info"));
    const { tab } = useParams();
    const [activeTab, setActiveTab] = useState(null);
    const tabs = role == 4 ? [
        { "name": "App Users", "path": "/user" },
    ] : [
        { "name": "App Users", "path": "/user" },
        { "name": "Super Users", "path": "/super-user" },
        { "name": "Ambassadors", "path": "/ambassador" },
        { "name": "Organization", "path": "/organization" },
        { "name": "Therapist", "path": "/therapist" },
    ];

    useEffect(() => {
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_ADMIN_URL : process.env.REACT_APP_ADMIN_URL_DEV);
        activeTab?.path && window.history.pushState({}, "", `${link}users-panel${activeTab?.path}`);
    }, [activeTab]);


    return (
        <div id="users-panel" className="custom-panel">
            <div className="panel-header">
                <h4>Users</h4>
            </div>
            <CustomPanelTab tabs={tabs}
                defaultTab={tabs?.find(t => t?.path == ('/' + tab))}
                setActiveTab={setActiveTab} />

            <div className="panel-content">
                {
                    activeTab?.name == "App Users" && <User />
                }
                {
                    activeTab?.name == "Super Users" && <SuperUser />
                }
                {
                    activeTab?.name == "Ambassadors" && <Ambassador />
                }
                {
                    activeTab?.name == "Organization" && <RegisteredOrganization />
                }
                {
                    activeTab?.name == "Therapist" && <Therapist />
                }
            </div>
        </div>
    );
}

export default PanelUser;